import React from 'react';
import PropTypes from 'prop-types';
import { COUNTRY_CODES_SOURCES } from '../../administration/clientPage/constants';

const CountryCodedOptionCellRenderer = ({ value }) => (
  <div>
    { COUNTRY_CODES_SOURCES[value].label }
  </div>
);

CountryCodedOptionCellRenderer.propTypes = {
  value: PropTypes.string.isRequired,
};

export default CountryCodedOptionCellRenderer;
